export default __webpack_public_path__ + "static/media/payment-1.ce14c860.svg";